import type { NavLink, SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Huzzah Studio',
    description: "Huzzah Studio is a small, senior creative agency for branding, websites, content and growth marketing. Brand work so good, people actually cheer.",
    url: getOrigin(),
    ogImage: 'https://huzzah-studio.cdn.modulify.website/share/hero-studio.jpg'
}

export const navLinks: NavLink[] = [
    { label: 'Services', href: '/#services' },
    { label: 'Work', href: '/#work' },
    { label: 'Process', href: '/#process' },
    { label: 'Reviews', href: '/#reviews' },
    { label: 'Pricing', href: '/#pricing' },
    { label: 'FAQ', href: '/#faq' }
]

export const contactDetails = {
    phone: '+1 (503) 555-0148',
    phoneHref: 'tel:+15035550148',
    email: 'hello@modulify.ai',
    street: '88 Marigold Lane',
    city: 'Portland, OR 97209',
    hours: 'Mon to Fri, 9am to 6pm PT'
}
